import React, { useState, useRef } from 'react'
import ContactLeft from './ContactLeft';
import emailjs from '@emailjs/browser';
import { motion } from 'framer-motion';

const Contact = () => {
  const form = useRef();
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const emailValidation = () => {
    return String(email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleSend = (e) => {
    e.preventDefault();
    if (username === "") {
      setErrMsg("Username is required!");
    } else if (phoneNumber === "") {
      setErrMsg("Phone number is required!");
    } else if (email === "") {
      setErrMsg("Please give your Email!");
    } else if (!emailValidation(email)) {
      setErrMsg("Give a valid Email!");
    } else if (subject === "") {
      setErrMsg("Please give your Subject!");
    } else if (message === "") {
      setErrMsg("Message is required!");
    } else {
      emailjs.sendForm('service_m07fbn1', 'template_eji89rf', form.current, 'nRzca5a_q8wvjv-3V')
      .then((result) => {
        setSuccessMsg(`Thank you dear ${username}, Your Messages has been sent Successfully!`);
      }, (error) => {
        setSuccessMsg(`Please try again`);
      });
      setErrMsg("");
      setUsername("");
      setPhoneNumber("");
      setEmail("");
      setSubject("");
      setMessage("");
    }
  };

  return (
    <section id="contact" className="w-full py-8">
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row gap-6">
          <ContactLeft />
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="w-full lgl:w-[60%] h-full py-6 rounded-xl border border-white/10 bg-white/5 backdrop-blur-md flex flex-col gap-5 p-5 lgl:p-6"
          >
            <form className="w-full flex flex-col gap-4" ref={form} onSubmit={handleSend}>
              {errMsg && (
                <p className="py-2 rounded-lg border border-red-500/30 bg-red-500/10 text-center text-red-400 text-xs tracking-wide animate-bounce">
                  {errMsg}
                </p>
              )}
              {successMsg && (
                <p className="py-2 rounded-lg border border-green-500/30 bg-green-500/10 text-center text-green-400 text-xs tracking-wide animate-bounce">
                  {successMsg}
                </p>
              )}

              <div className="w-full flex flex-col lgl:flex-row gap-4">
                <div className="w-full lgl:w-1/2 flex flex-col gap-2">
                  <p className="text-xs text-gray-400 uppercase tracking-wide">Your name</p>
                  <input
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    className="contactInput"
                    type="text"
                    name="from_name"
                    placeholder="John Doe"
                  />
                </div>
                <div className="w-full lgl:w-1/2 flex flex-col gap-2">
                  <p className="text-xs text-gray-400 uppercase tracking-wide">Phone Number</p>
                  <input
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    value={phoneNumber}
                    className="contactInput"
                    type="text"
                    name="number"
                    placeholder="+1 234 567 890"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <p className="text-xs text-gray-400 uppercase tracking-wide">Email</p>
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  className="contactInput"
                  type="email"
                  name="email"
                  placeholder="john@example.com"
                />
              </div>

              <div className="flex flex-col gap-2">
                <p className="text-xs text-gray-400 uppercase tracking-wide">Subject</p>
                <input
                  onChange={(e) => setSubject(e.target.value)}
                  value={subject}
                  className="contactInput"
                  type="text"
                  name="subject"
                  placeholder="Project Inquiry"
                />
              </div>

              <div className="flex flex-col gap-2">
                <p className="text-xs text-gray-400 uppercase tracking-wide">Message</p>
                <textarea
                  onChange={(e) => setMessage(e.target.value)}
                  value={message}
                  className="contactTextArea"
                  cols="30"
                  rows="5"
                  name="message"
                  placeholder="Tell me about your project..."
                ></textarea>
              </div>

              <div className="w-full">
                <button
                  type="submit"
                  className="w-full h-10 rounded-lg text-xs font-medium text-white bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 hover:from-cyan-500/30 hover:to-blue-500/30 hover:border-cyan-400/50 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 uppercase tracking-wider"
                >
                  Send Message
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Contact
